export default {
    variant: 'cards.primary',
    p: 4,
    borderStyle: `solid`,
    borderColor: `articleBorder`,
    borderWidth: 'sm',
    bg: 'cardsBg'
  }
  